/**
 * SessionStorage key for endorsements experiment value
 */
export const ENDORSEMENTS_EXPERIMENT_KEY = 'starterExperienceDashboardEndorsementsExperiment';
